import { Actions, ActionTypes } from './actions';
import { initialState, PermissionsState } from './state';

export function PermissionReducer(state = initialState, action: Actions): PermissionsState {
   switch (action.type) {
      case ActionTypes.REMOVED_REQUIRED_LIST:
         return {
           ...state,
         };
       case ActionTypes.REMOVED_REQUIRED_LIST_COMPLETE:
         return {
           ...state,
           givenPermissionsSent: action.payload,
         };
         case ActionTypes.PERMISSIONS_LIST:
          return {
            ...state,
          };
        case ActionTypes.PERMISSIONS_LIST_COMPLETE:
          return {
            ...state,
            givenPermissionsGrant: action.payload,
          };
          case ActionTypes.ALREADY_PERMISSION_SENT_LIST:
            return {
              ...state,
            };
          case ActionTypes.ALREADY_PERMISSION_SENT_LIST_COMPLETE:
            return {
              ...state,
              receivedPermissionsSent: action.payload,
            };
            case ActionTypes.ALREADY_PERMISSION_APPROVED_LIST:
              return {
                ...state,
              };
            case ActionTypes.ALREADY_PERMISSION_APPROVED_LIST_COMPLETE:
              return {
                ...state,
                receivedPermissionsGrant: action.payload,
              };
      default: {
         return state;
      }
    }
 }

